import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { OverwriteStructureWarningModal } from "@src/components/organisms/modals/overwrite-structure-warning-modal/overwrite-structure-warning-modal";

export const OverwriteStructure = () => {
  const showOverwriteStructureWarningModal = useSelector(
    (state: RootState) => state.yourSlice.showOverwriteStructureWarningModal,
  );

  return (
    <>
      {showOverwriteStructureWarningModal && <OverwriteStructureWarningModal />}
    </>
  );
};
